










































import Vue from 'vue'
import Loader from '@/components/ui/Loader/Loader.vue'
import WeatherStationDetail from './WeatherStationDetail.vue'

export default Vue.extend({
  name: 'WeatherStationListing',
  components: {
    'ui-loader': Loader,
    'weather-station-detail': WeatherStationDetail
  },
  props: {
    loading: Boolean,
    stations: {
      type: Array,
      default: () => ([])
    },
    stationsData: {
      type: Object,
      default: () => ({})
    },
    // used in custom dashboard
    // refer to the reference property of the station
    currentStation: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: 'Stations'
    },
    displayTitle: {
      type: Boolean,
      default: true
    },
    displayBadges: {
      type: Boolean,
      default: true
    },
    displayTime: {
      type: Boolean,
      default: true
    },
    trackOrWbgt: {
      type: String,
      default: 'track'
    }
  },
  data: () => ({
    currentStationId: null
  }),
  computed: {
    currentStationsData () {
      if (this.currentStationId) {
        return this.stationsData[this.currentStationId]
      } else {
        return this.stationsData[this.stations[0]?.id]
      }
    }
  },
  mounted () {
    if (this.currentStation) {
      const currentStation = this.stations.find(s => parseInt(s.properties.reference) === this.currentStation)
      this.currentStationId = currentStation?.id
    }
  }
})
